import api from '@/data/fetchType.js';
/*
 * @Author: lgg
 * @Date: 2022-04-12 16:09:27
 * @LastEditors: lgg
 * @LastEditTime: 2022-05-18 17:08:13
 */

function getList(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/task/getTask', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function getAssistList(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/task/getAssistTask', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function taskDeal(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/workFlow/deal', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function getTaskTypeList(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/task/getTaskType', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
function getCountTaskByDefName(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/task/getCountTaskByDefName', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
function getCountAssistTaskByDefName(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/task/getCountAssistTaskByDefName', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
export {
  getList,
  taskDeal,
  getTaskTypeList,
  getAssistList,
  getCountTaskByDefName,
  getCountAssistTaskByDefName
};
